var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-icon-button md-raised md-primary md-fab",
              attrs: { to: "/" }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
        },
        [
          _vm.currentPath !== "/login"
            ? _c(
                "h3",
                { staticClass: "signin-warning" },
                [
                  _vm._v(
                    "\n        Um diese Funktion nutzen zu können, melden Sie sich bitte an. "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        Falls Sie keinen Account haben, können Sie sich\n        "
                  ),
                  _c("router-link", { attrs: { to: { name: "Signup" } } }, [
                    _vm._v(" hier")
                  ]),
                  _vm._v(" kostenlos\n        registrieren.\n      ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateUser.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [_vm._v("Anmelden")])
                  ]),
                  _vm._v(" "),
                  _c("md-card-content", [
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("email") },
                            [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v("Email")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  type: "email",
                                  name: "email",
                                  id: "email",
                                  autocomplete: "email",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.email.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Die Mail-Adresse wird benötigt")
                                  ])
                                : !_vm.$v.form.email.email
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültige Mail-Adresse")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("password") },
                            [
                              _c("label", [_vm._v("Password")]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "password",
                                  type: "password",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.password.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Das Passwort wird benötigt")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    this.error
                      ? _c("span", { staticClass: "md-error" }, [
                          _vm._v(_vm._s(this.message))
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _vm.sending
                    ? _c("md-progress-bar", {
                        attrs: { "md-mode": "indeterminate" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("Anmelden")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("md-dialog-prompt", {
                        attrs: {
                          "md-active": _vm.active,
                          "md-title": "Sie haben Ihr Passwort vergessen?",
                          "md-content":
                            "Hier können Sie einen Passwort-Reset anfordern. Danach wird Ihnen per Email ein Link zugesandt, unter dem Sie Ihr Passwort ändern können. Bitte geben Sie dazu die Email-Adresse ein, die Sie bei Ihrer Registrierung verwendet haben.",
                          "md-input-placeholder": "Email-Adresse",
                          "md-confirm-text": "Passwort zurücksetzen",
                          "md-cancel-text": "Abbrechen"
                        },
                        on: {
                          "update:mdActive": function($event) {
                            _vm.active = $event
                          },
                          "update:md-active": function($event) {
                            _vm.active = $event
                          },
                          "md-cancel": _vm.onCancel,
                          "md-confirm": _vm.onConfirm
                        },
                        model: {
                          value: _vm.forgotPassMail,
                          callback: function($$v) {
                            _vm.forgotPassMail = $$v
                          },
                          expression: "forgotPassMail"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-accent md-dense",
                          on: {
                            click: function($event) {
                              _vm.active = true
                            }
                          }
                        },
                        [_vm._v("Passwort vergessen")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f43afc94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f43afc94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/authentication/signin/Signin.vue
// module id = null
// module chunks = 